import { getPartialTaskFromTodo, updateTaskService } from 'owa-todo-service';
import { getTodoCache } from '../todoCache';
import type { Todo } from 'owa-todo-types';
import { trace } from 'owa-trace';

export function updateTodo(itemId: string, todoUpdates: Partial<Todo>): Promise<boolean> {
    if (todoUpdates?.hasOwnProperty('Subtasks')) {
        // safety net to avoid updating subtasks when calling this function
        trace.warn(
            "Call to 'updateTodo' should not update Subtasks. Instead, call 'updateSubtodo'"
        );
        return Promise.resolve(false);
    }

    const updates = getPartialTaskFromTodo(todoUpdates);

    if (!updates) {
        return Promise.resolve(true);
    }
    getTodoCache().updateItem(itemId, todoUpdates);
    return updateTaskService(updates, itemId);
}
